import Auth from '../api/auth';
import { logArdhisasaApiError } from 'dashboard/lib/ardhisasaErrorLogger';

const parseErrorCode = error => Promise.reject(error);

const isArdhisasaEndpoint = url =>
  typeof url === 'string' &&
  url.includes('/ardhisasa/') &&
  !url.includes('/errors/log');

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => {
      const url = error?.config?.url || '';
      if (isArdhisasaEndpoint(url) && error?.response) {
        logArdhisasaApiError(
          url,
          error.response.status,
          JSON.stringify(error.response.data).slice(0, 300)
        );
      }
      return parseErrorCode(error);
    }
  );
  return wootApi;
};
